export default __webpack_public_path__ + "static/media/alari.2c827f9c.webp";